import React from 'react'
import { Filters, UserList } from 'components'
import StyledBrowse from './StyledBrowse'

const Browse = () => (
  <StyledBrowse>
    <Filters />
    <UserList pagination placeholders={18} filter="new,online" />
  </StyledBrowse>
)

export default Browse
